/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-12-13 09:19:15
 * @LastEditTime : 2022-12-13 15:52:47
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\schedul\dockPlan.js
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/basics/plan/queryExtermalPlanPage'

/*获取工程列表*/
export function queryExterEngineeringList(params) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/queryExterEngineeringList',
    method: 'get',
    params
  })
}
/*查看外部订单及绑定订单详情*/
export function getThirdPlanDetail(params) {
    return request({
      url: '/icps/system/sign/basics/plan/getThirdPlanDetail',
      method: 'get',
      params
    })
  }
/*新增订单详情*/
export function saveDockingPlan(data) {
    return request({
      url: '/icps/system/sign/basics/plan/saveDockingPlan',
      method: 'post',
      data
    })
  }
/*取消订单*/
export function deleteExternalPlan(data) {
    return request({
      url: '/icps/system/sign/basics/plan/deleteExternalPlan',
      method: 'post',
      data
    })
  }
